__turbopack_context__.v({
  "chip": "WSearch-module__8RAa8W__chip",
  "chips": "WSearch-module__8RAa8W__chips",
  "close": "WSearch-module__8RAa8W__close",
  "form": "WSearch-module__8RAa8W__form",
  "group": "WSearch-module__8RAa8W__group",
  "groupTitle": "WSearch-module__8RAa8W__groupTitle",
  "header": "WSearch-module__8RAa8W__header",
  "iconButton": "WSearch-module__8RAa8W__iconButton",
  "input": "WSearch-module__8RAa8W__input",
  "inputIcon": "WSearch-module__8RAa8W__inputIcon",
  "inputWrap": "WSearch-module__8RAa8W__inputWrap",
  "listbox": "WSearch-module__8RAa8W__listbox",
  "loading": "WSearch-module__8RAa8W__loading",
  "mark": "WSearch-module__8RAa8W__mark",
  "modal": "WSearch-module__8RAa8W__modal",
  "notConfigured": "WSearch-module__8RAa8W__notConfigured",
  "option": "WSearch-module__8RAa8W__option",
  "optionActive": "WSearch-module__8RAa8W__optionActive",
  "overlay": "WSearch-module__8RAa8W__overlay",
  "popular": "WSearch-module__8RAa8W__popular",
  "popularLabel": "WSearch-module__8RAa8W__popularLabel",
  "root": "WSearch-module__8RAa8W__root",
  "title": "WSearch-module__8RAa8W__title",
});
